/* eslint-disable max-len */
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/rootState';
import { setTableContent } from '../redux/reportPdfSlice';

function TableContentSection() {
  const {
    checkedSections, themePdfColor,
  } = useSelector((state:RootState) => state.reportPdfSliceReducer);
  const { allListContents } = useSelector((state:RootState) => state.reportWorkspaceReducer);
  const { BorderColor, MainColor } = themePdfColor;
  const dispatch = useDispatch();

  // const tableContent: string[] = useMemo(() => {
  //   if (!checkedSections) {
  //     return [];
  //   }

  //   const contents = checkedSections.slice(0, -1).map((item) => {
  //     const content = allListContents.find((ele) => ele.PartNumber === Number(item));
  //     if (content) {
  //       return content.Title;
  //     }
  //     return '';
  //   });

  //   // Find the index of the item with PartNumber 4
  //   const index = checkedSections.findIndex((item) => Number(item) === 4);
  //   if (index !== -1) {
  //     // Insert 'Support Bay Length' right after the item with PartNumber 4
  //     contents.splice(index + 1, 0, 'Support Bay Length');
  //   }
  //   dispatch(setTableContent(contents));
  //   return contents;
  // }, [checkedSections, allListContents]);

  const tableContent: string[] = useMemo(() => {
    if (!checkedSections) {
      return [];
    }

    const contents = checkedSections
      .slice(0, -1)
      .map((item) => {
        const content = allListContents.find((ele) => ele.PartNumber === Number(item));
        if (content) {
          return content.Title;
        }
        return '';
      })
      .filter((title) => title !== 'Calibration Procedure'
        && title !== 'Calibration Procedure (from 1st Job)'
        && title !== 'Explanation Of Abbreviations' // Filter out titles
        && title !== 'Inspection Procedure' // Filter out titles
        && title !== 'Expense Report' // Filter out titles
        && title !== 'Expense Report (from all Jobs)', // Filter out titles
      // eslint-disable-next-line function-paren-newline
      );

    // Find the index of the item with PartNumber 4
    const index = checkedSections.findIndex((item) => Number(item) === 4);
    if (index !== -1) {
      // Insert 'Support Bay Length' right after the item with PartNumber 4
      contents.splice(index + 1, 0, 'Support Bay Length');
    }

    // Remove any text within brackets along with the brackets themselves
    const removedBracketStrings = contents?.map((str) => str?.replace(/\s*\([^)]*\)/g, '')?.trim());
    dispatch(setTableContent(removedBracketStrings));
    return removedBracketStrings;
  }, [checkedSections, allListContents]);

  const alphaSections = useMemo(() => [
    { id: 1, label: 'Inspection Report', visible: tableContent?.length > 1 },
    { id: 2, label: 'Calibration Procedure', visible: checkedSections?.includes('13') },
    { id: 3, label: 'Inspection Procedure', visible: checkedSections?.includes('15') },
    { id: 4, label: 'Expense Report', visible: checkedSections?.includes('17') },
    { id: 5, label: 'Explanation of Abbreviations', visible: checkedSections?.includes('14') },
  ], [tableContent, checkedSections]);

  const visibleAlphaSections = useMemo(() => alphaSections?.filter(
    (section) => section?.visible,
  ).map((item, index) => ({ ...item, sectionTitle: String.fromCharCode(65 + index) })), [alphaSections]);

  return (
    <div className="p10">
      <table className="w100 logoTable">
        <tr>
          <td>
            <div className="commonTableBorderStyle mt10 pageBorder1000" style={{ borderColor: MainColor }}>
              <div
                className="tableAfterBorderStyle"
                style={{
                  backgroundColor: BorderColor,
                }}
              />
              <div
                className="tableBeforeBorderStyle"
                style={{
                  backgroundColor: BorderColor,
                }}
              />
              <table className="w100">
                <tr>
                  <td className="p20">&nbsp;</td>
                </tr>
                <tr>
                  <td className="textCenter bayLengthHeader">
                    Table of Contents
                  </td>
                </tr>
                <tr>
                  <td className="p20">&nbsp;</td>
                </tr>
                {tableContent?.length > 1 && (
                <tr>
                  <td className="textCenter tableContent">
                    <div className="tableContentList">
                      {`Section ${visibleAlphaSections?.find((item) => item.id === 1)?.sectionTitle} . . . . . . . . . . . . . . . Inspection Report`}
                    </div>
                  </td>
                </tr>
                )}
                <tr>
                  <td className="p0">&nbsp;</td>
                </tr>
                <tr>
                  <td className="textCenter tableContent">
                    <div className="tableContentList pl40">
                      {tableContent?.map((content, index) => (
                        index > 0 && (
                          content === 'Strip Charts' ? (
                            <>
                              <p>{`Part ${index}  . . . . . . . . . . . . . . . ${content}`}</p>
                              <div className="pl30">
                                <p>{`Part ${index}.1  . . . . . . . . . . . . . . . Calibration ${content}`}</p>
                                <p>{`Part ${index}.2  . . . . . . . . . . . . . . . Tube ${content}`}</p>
                              </div>
                            </>
                          ) : (
                            <p>{`Part ${index}  . . . . . . . . . . . . . . . ${content}`}</p>
                          )
                        )
                      ))}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="p0">&nbsp;</td>
                </tr>
                {checkedSections?.includes('13') && (
                <tr>
                  <td className="textCenter tableContent">
                    <div className="tableContentList">
                      {`Section ${visibleAlphaSections?.find((item) => item.id === 2)?.sectionTitle} . . . . . . . . . . . . . . . Calibration Procedures`}
                    </div>
                  </td>
                </tr>
                )}
                <tr>
                  <td className="p0">&nbsp;</td>
                </tr>
                {checkedSections?.includes('15') && (
                <tr>
                  <td className="textCenter tableContent">
                    <div className="tableContentList">
                      {`Section ${visibleAlphaSections?.find((item) => item.id === 3)?.sectionTitle} . . . . . . . . . . . . . . . Inspection Procedures`}
                    </div>
                  </td>
                </tr>
                )}
                <tr>
                  <td className="p0">&nbsp;</td>
                </tr>
                {checkedSections?.includes('17') && (
                <tr>
                  <td className="textCenter tableContent">
                    <div className="tableContentList">
                      {`Section ${visibleAlphaSections?.find((item) => item.id === 4)?.sectionTitle} . . . . . . . . . . . . . . . Expense Report`}
                    </div>
                  </td>
                </tr>
                )}
                <tr>
                  <td className="p0">&nbsp;</td>
                </tr>
                {checkedSections?.includes('14') && (
                <tr>
                  <td className="textCenter tableContent">
                    <div className="tableContentList">
                      {`Section ${visibleAlphaSections?.find((item) => item.id === 5)?.sectionTitle} . . . . . . . . . . . . . . . Explanation of Abbreviations`}
                    </div>
                  </td>
                </tr>
                )}
                <tr>
                  <td className="p20">&nbsp;</td>
                </tr>
              </table>
            </div>
            <div className="copyright-text">Copyright (c) 2009-24, TAI Services, Inc.</div>
          </td>
        </tr>
      </table>
    </div>
  );
}

export default TableContentSection;
